import React, { Component } from 'react';
import loadScripts from '../../dassets/js/custom';
import { Link } from 'react-router-dom';

class About extends Component {
  componentDidMount() {
    loadScripts();
  }
  render() {
    return (
      <>
        {/* =================================
    Inner Header */}
        <div className="inner-header bg-light">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-sm-6 text-sm-start mb-2 mb-sm-0">
                <h1 className="breadcrumb-title mb-0">About us</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb d-flex justify-content-center justify-content-sm-end ms-auto">
                  <li className="breadcrumb-item"><Link to={"/"}><i className="fas fa-home me-1"></i>Home</Link></li>
                                    <li className="breadcrumb-item"><span>About</span></li>
                  <li className="breadcrumb-item active"><span>About us</span></li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* =================================
  Inner Header */}

        {/* =================================
  Tab */}
        <section className="space-pt pb-4">
          <div className="container">
            <div className="row d-flex align-content-center flex-wrap">
              <div className="col-md-12 align-self-center ps-3 ps-lg-5">
                <div className="row">
                  <div className="col-12">
                    <div className="nav mb-4 nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                      <a className="nav-link active" id="v-pills-who-we-are-tab" data-bs-toggle="pill" href="#v-pills-who-we-are" role="tab" aria-controls="v-pills-who-we-are" aria-selected="true">Who we are</a>
                      <a className="nav-link" id="v-pills-our-vision-tab" data-bs-toggle="pill" href="#v-pills-our-vision" role="tab" aria-controls="v-pills-our-vision" aria-selected="false">Our vision</a>
                      <a className="nav-link" id="v-pills-our-mission-tab" data-bs-toggle="pill" href="#v-pills-our-mission" role="tab" aria-controls="v-pills-our-mission" aria-selected="false">Our mission</a>
                      <a className="nav-link" id="v-pills-our-history-tab" data-bs-toggle="pill" href="#v-pills-our-history" role="tab" aria-controls="v-pills-our-history" aria-selected="false">Our philosophy</a>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="tab-content" id="v-pills-tabContent">
                      <div className="tab-pane fade show active" id="v-pills-who-we-are" role="tabpanel" aria-labelledby="v-pills-who-we-are-tab">
                        <div className="row">
                          <div className="col-lg-12 mb-lg-0 mb-4">
                            <h4 className="mb-3">Our Company Has Gained Trust Over The Past <span>29+</span> Years</h4>
                            <p>Dynamic Portfolio Limited ("Dynamic" or "the Company") was incorporated on 8th June, 1993 as a private limited liability company with the objective of providing world class investment advisory services which are tailor made to meet the specific needs of our local and international clients.</p>
                            <p className="mb-4">Accordingly, the company is registered and regulated by the Securities & Exchange Commission (SEC) and The Nigerian Exchange Group as Issuing House and Broker/Dealer.  Our current authorized share capital and net assets is in excess of N1.0 billion.</p>

                <p className="mb-4">Dynamic Portfolio Limited is a major player in the Nigerian Capital Market and is strategically located on the Penthouse and second floor of Dynamic House, 20, Campbell Street, within the nucleus of Nigeria's financial nerve centre, Lagos. We have successfully acted as Financial Advisers, Issuing Houses and Stockbrokers to major primary market transactions in Nigeria.</p>
                            <div className="row">
                              <div className="col-lg-6 col-md-6 mb-md-5 mb-4">
                                <div className="feature-info feature-info-style-3">
                                  <div className="feature-info-icon">
                                    <i className="flaticon-shield"></i>
                                  </div>
                                  <div className="feature-info-content">
                                    <h6 className="feature-info-title">Trusted and Secured</h6>
                                    <p>Our clients trust us because their funds and information are secured with us.</p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6 mb-md-5 mb-4">
                                <div className="feature-info feature-info-style-3">
                                  <div className="feature-info-icon">
                                    <i className="flaticon-money"></i>
                                  </div>
                                  <div className="feature-info-content">
                                    <h6 className="feature-info-title">Fund Management</h6>
                                    <p>We actively help you to grow and manage your funds.</p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6 mb-md-5 mb-4">
                                <div className="feature-info feature-info-style-3">
                                  <div className="feature-info-icon">
                                    <i className="flaticon-telemarketer"></i>
                                  </div>
                                  <div className="feature-info-content">
                                    <h6 className="feature-info-title">Continuous Support</h6>
                                    <p>We provide 24X7 support for all our customers</p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6 col-md-6 mb-md-0 mb-4">
                                <div className="feature-info feature-info-style-3">
                                  <div className="feature-info-icon">
                                    <i className="flaticon-team"></i>
                                  </div>
                                  <div className="feature-info-content">
                                    <h6 className="feature-info-title">100% Clients' Satisfaction</h6>
                                    <p>Our testimonials show how satisfied our clients are with our services.</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="v-pills-our-vision" role="tabpanel" aria-labelledby="v-pills-our-vision-tab">
                        <h6 className="mb-3">Our Vision </h6>
                        <p>To be the foremost Investment Banking Services Firm, providing unequaled services and satisfaction to our select clientele.</p>
                      </div>
                      <div className="tab-pane fade" id="v-pills-our-mission" role="tabpanel" aria-labelledby="v-pills-our-mission-tab">
                        <h6 className="mb-3">Our Mission </h6>
                        <p>Given the fact that we are committed to the provision of satisfactory services to our clients with all the necessary resources around us, we aspire to be the leading capital market services provider with high quality service delivery to our select clientele.</p>
                      </div>
                      <div className="tab-pane fade" id="v-pills-our-history" role="tabpanel" aria-labelledby="v-pills-our-history-tab">
                        <h6 className="mb-3">Our Philosophy </h6>
                        <p>We believe that we can only afford to go to sleep, if our clients' needs are met and satisfaction are obvious. Always, we place ourselves in the clients' position expecting to get the same quality of services that we provide and that are worthy to others after financial commitments are made.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* =================================
  Tab */}

        <section className="mt-2 pt-4 pb-4">
          <div className="container">
            <div className="row">
              <div id='oa' className="col-12 mb-4 mb-md-5">
                <h5 className="mb-3">Our Approach</h5>
                <p>Dynamic Portfolio Limited will undertake to execute and render returns promptly on capital market assignments given to her by the client.<br />
                  Dynamic Portfolio Limited will furnish the client with realtime market information and activities as they occur on the floor of The Nigerian Exchange Group, i.e. daily reports.<br />
                  A carefully researched and articulate analysis of selected quoted companies would be undertaking periodically and constantly, and same forwarded electronically, for the investment decision of the clients.<br />
                  Dynamic Portfolio Limited will undertake to advice and where necessary, assist the client to actualise its set goals, particularly in the area of capital raising, and will strive to meet the client's needs in all aspects of financial intermediation, when the need arises.</p>
              </div>
              <div id='wp' className="col-12 mb-4 mb-md-5">
                <h5 className="mb-3">Why we are preferred</h5>
                <p>We provide cutting edge professional services with particular focus on the security of our clients' wealth through the timely dissemination of information to guide them on investment decision making and proficient execution of mandates. This, we have been able to sustain over the years.</p>
              </div>
            </div>
          </div>
        </section>

        {/* <!--=================================
Counter --> */}
        <div className="position-relative">
            <div className="counter bg-dark">
          <div className="container">
              <div className="row">
                <div className="col-sm-6 col-lg-6 mb-4 mb-lg-0 position-relative">
                  <div className="counter-item">
                    <div className="counter-icon">
                      <i className="flaticon-clock"></i>
                    </div>
                    <div className="counter-content">
                      <span className="timer text-white" data-to="29" data-speed="1000">29</span>
                      <label className="text-white">Years of Experience</label>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-6 mb-4 mb-lg-0 position-relative">
                  <div className="counter-item">
                    <div className="counter-icon">
                      <i className="flaticon-team"></i>
                    </div>
                    <div className="counter-content">
                      <span className="timer text-white" data-to="3796" data-speed="1000">3796</span>
                      <label className="text-white">Happy Clients</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--=================================
Counter --> */}

        {/* <!--=================================
    Client Logo --> */}
        <section className="pt-3 pb-3">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="owl-carousel our-clients" data-nav-arrow="false" data-items="6" data-md-items="5" data-sm-items="4" data-xs-items="3" data-xx-items="1" data-space="30" data-autoheight="true" data-autospeed="4000">
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/01.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/02.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/03.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/09.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/04.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/05.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/06.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/07.png")} alt="" />
                  </div>
                  <div className="item">
                    <img className="img-fluid p-3" src={require("../../dassets/images/client/08.png")} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--=================================
    Client Logo --> */}
      </>
    );
  }
}

export default About;